// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#505d6a","menuText":"#fff","menuActiveText":"#fcdedd"};